import React from 'react';

const WelcomeToDashboard = () => {
    return (
        <div>
            <h1 className='text-xl lg:text-3xl font-bold text-primary-focus'>Welcome to dashboard</h1>
        </div>
    );
};

export default WelcomeToDashboard;